import React, {Component} from 'react'
import {NavLink} from 'react-router-dom'
import {UserNav, AlertCard} from './../../../components'
import Router from './../../../services/Router'
import { ButtonRouter, CounterfeitsContainer } from './../../../styles'
import { withLoader } from '../../../hoc/withLoader'

class Counterfeits extends Component {
  state = {
    counterfeits: []
  }

  render () {
    const { data, isReady } = this.props
    return (
      <div className={`fluid counterfeits ${CounterfeitsContainer} `}>
        <UserNav />
        <div className="filter-counterfeits">
          <ul className={`reset ${ButtonRouter} flex`}>
              <li>
                <NavLink to={Router.counterfeits.path} exact> <span>Counterfeits</span> </NavLink>
              </li>
              <li>
                <NavLink to={Router.thefts.path} exact> <span>Thefts</span> </NavLink>
              </li>
           </ul>
          </div>
        <div className={`counterfeits-container transition ${isReady ? 'transition--ready': ''}`}>
          {
            data && data.counterfeits.map((counterfeit, index) => (
              <AlertCard {...counterfeit} key={index} />
            ))
          }
        </div>
      </div>
    )
  }
}

export default withLoader(Counterfeits, '/alerts/counterfeits')


// WEBPACK FOOTER //
// ./src/scenes/Pages/container/Counterfeits.js